import { Box, Row, Skeleton, Text } from 'native-base'
import { useMemo } from 'react'

import { PointsIndicator } from './PointsIndicator'

import { useDeviceInfo } from '~hooks'
import { useGetUser } from '~query-hooks'
type ScreenHeaderWithPointsProps = {
  title: string
}

export const ScreenHeaderWithPoints = ({ title }: ScreenHeaderWithPointsProps) => {
  const { user, isLoadingUser } = useGetUser()
  const { points } = user || {}

  const { shouldApplyDesktopStyles } = useDeviceInfo()
  const renderPoints = useMemo(
    () =>
      shouldApplyDesktopStyles ? null : (
        <PointsIndicator balance={points || '0'} variant="primary" withText={false} />
      ),
    [points, shouldApplyDesktopStyles]
  )
  return (
    <Row justifyContent="space-between" px={4} w="full">
      <Text fontWeight="bold" fontSize="2xl">
        {title}
      </Text>
      {isLoadingUser ? (
        <Box flexGrow={1} alignItems="flex-end" justifyContent="center">
          <Skeleton.Text lines={1} width="30%" fontSize="4xl" />
        </Box>
      ) : (
        renderPoints
      )}
    </Row>
  )
}
